import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function fetchCustomerUserMeterEnergyDate(condition){
  return request({
    url: cmsServerContext + '/dataAnalysis/energyDataQuery',
    method: 'post',
    data: condition
  })
}